import React from "react";
import style from "./assessmentNotes.module.scss";
import { signedLockedAccess } from "../../../../utils";
import { ZoomPhoto } from "../Photos";
import NotesDeleteConfirmationModal from "./notesDeleteConfirmationModal";
import { Spinner } from "../../../secondary/Loader/Spinner";
import { useAssessmentNotes } from "./useAssessmentNotes";
import { StatusAlerts } from "./StatusAlerts";
import { NoteForm } from "./NoteForm";
import { NotesList } from "./NotesList";
import { ReadOnlyBanner } from "../../../secondary/ReadOnlyBanner/ReadOnlyBanner";

export const AssessmentNotes = ({ hideIt }) => {
  const {
    register,
    handleSubmit,
    reset,
    doSubmit,
    notes,
    detailAssessment,
    measurementData,
    deleteAssessmentNoteState,
    assessmentNotesLoading,
    woundImageLoading,
    setWoundImageLoading,
    deleteConfirmationModal,
    setDeleteConfirmationModal,
    handleDeleteNote,
    handleDeleteAssessmentNote,
    isReadOnly,
  } = useAssessmentNotes();

  if (assessmentNotesLoading) return <Spinner />;

  return (
    <div>
      <StatusAlerts deleteAssessmentNoteState={deleteAssessmentNoteState} />

      <div className="row d-flex row no-gutters">
        <div className="col-4" style={{ overflow: "hidden" }}>
          <div className={style.patient_wound}>
            <ZoomPhoto
              image={measurementData?.assessedImageSASURL || measurementData?.intialImageSASURL || detailAssessment?.picture}
              loading={woundImageLoading}
              setLoading={setWoundImageLoading}
              showBottomBtn={false}
              classes={{
                outerClass: undefined,
                innerClass: "position-relative w-100",
                shimmerClass: style.image_skleton,
              }}
              showTopBtn={detailAssessment?.isWoundWithoutPhoto === 0}
            />
          </div>
        </div>

        <div className="col-8 w-100">
          { isReadOnly && <div className="ml-4"><ReadOnlyBanner /></div> }
          <div className={`${style.notes_conatiner} w-100`}>
            {hideIt && signedLockedAccess(detailAssessment?.assessmentStage) ? (
              <NoteForm register={register} handleSubmit={handleSubmit} doSubmit={doSubmit} reset={reset} />
            ) : (
              "This wound assessment is signed and locked, cannot be updated."
            )}

            <NotesList notes={notes} assessmentStage={detailAssessment?.assessmentStage} onDeleteNote={handleDeleteAssessmentNote} isReadOnly={isReadOnly} />
          </div>
        </div>
      </div>

      {deleteConfirmationModal && <NotesDeleteConfirmationModal setDeleteModal={setDeleteConfirmationModal} handleDelete={handleDeleteNote} />}
    </div>
  );
};
